/* Login component */
import * as React from 'react';
import { Button, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import Auth from '../auth/auth';
import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { EmailLinkComponent } from '../common/navigation';
import AppConfiguration from '../config/configuration';
import * as ReduxQueries from '../queries';

class Login extends AppComp.AppComponent {
  public constructor(props: any) {
    super(props, 'app.login.');
  }

  public renderSupportEmailLink = (hideIcon: boolean = true) => {
    const supportEmail = AppConfiguration.getSupportEmail();

    return (supportEmail) ? (
      <EmailLinkComponent
        email={supportEmail}
        hideIcon={hideIcon}
        caption={`${this.appTextCommon('contacts.send-email-to')} ${supportEmail}`}
      />) : undefined;
  }

  public render() {
    let page = (
      <Well className="app-login-well">
        <Row className="app-login-panel">
          <Col xs={12}>
            <div className="app-login-header">
              <h1>{this.appText('login-account-login')}</h1>
            </div>

            <div className="app-login-text">
              <p>{this.appText('login-instructions-1')} {this.appText('login-instructions-2')} {this.renderSupportEmailLink()}.</p>
            </div>

            <div className="app-login-button-container">
              <Row>
                <Col xs={2} />
                <Col xs={8}>
                  <Button
                    bsSize="large"
                    bsStyle="success"
                    block={true}
                    onClick={e => { this.handleLoginButton(e); }}
                  >
                    {this.appText('login')}
                  </Button>
                </Col>
                <Col xs={2} />
              </Row>
            </div>
          </Col>
        </Row>
      </Well>
    );

    return page;
  }

  private handleLoginButton(e: any) {
    // Handle login button click: begin Auth0 login process via redirect
    const auth = new Auth();

    auth.login();

    return;
  }
}

const mapStateToProps = (state, props) => {
  return ReduxQueries.MapQueryStateToPropsRoot(state, props);
};

const LoginContainer = compose<any>(
  connect(mapStateToProps),
)(Login);

export default withRouter(LoginContainer);



// WEBPACK FOOTER //
// ./src/login/index.tsx